import "./TradeListingGrowing.css";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
// import CommunityBarChart from "../../../sharedPages/MarketPlace/CommunityBarChart.js";
import CommunityBarChart from "../../../sharedPages/MarketPlace/CommunityBarChart.jsx";
import CustomSwitch from "../../../sharedPages/CommonComponents/CustomSwitch/CustomSwitch.jsx";
import useApi from "../../../../helpers/apiHelper/requestHelper.js";
import TradingGraphPnl from "../TradingGraphPnl.jsx";
import { isOlderThan7Days, simplifyTradingVolume } from "../../../../helpers/helper.js";
import { CommunityAreaChartTabs } from "../../../sharedPages/MarketPlace/CommunityAreaChart.jsx";
import { useDashboardMarket } from "../../../sharedPages/CommonComponents/DashboardMarketSelect/DashboardMarketContext";

const cards = [
  { cardTitle: "PNL" },
  // { cardTitle: "Monthly growth" }
];

const TradeListingGrowing = () => {
  const [activeButton, setActiveButton] = useState("Day");
  const [activeTab, setActiveTab] = useState(0);
  const [isShowContent, setIsShowContent] = useState(0);
  const [stats, setStats] = useState({});
  const [pnlPercentage, setPnlPercentage] = useState(0);
  const [thisWeekPnlPercentage, setThisWeekPnlPercentage] = useState(0);
  const api = useApi();
  const { user } = useSelector((state) => state.user);
  const community = useSelector(
    (state) => state?.user?.user?.leaderCommunity
  );
  const { selectedMarket } = useDashboardMarket();
  useEffect(() => {
    const fetchStats = async () => {
      if (!user?._id) return;
      const response = await api(
        "get",
        `multiCommunity/getCurrentStats/${user._id}`
      );
      if (response?.status && response.data) {
        setPnlPercentage(simplifyTradingVolume(response.data.pnlPercentage));
        setThisWeekPnlPercentage(simplifyTradingVolume(response.data.thisWeekPnlPercentage));
      }
    };
    fetchStats();
  }, []);
  const getUserStats = async () => {
    const response = await api("post", "multiCommunity/getSpecificUserStats", {
      userIds: [user?._id],
    });
    if (response?.status){
      setPnlPercentage(simplifyTradingVolume(response?.data.pnlPercentage));
      setThisWeekPnlPercentage(simplifyTradingVolume(response?.data.thisWeekPnlPercentage));
      
    } 
  };

  useEffect(() => {
    if (user) getUserStats();
  }, [user]);
  return (
    <div className="tradeListingGrowingBox">
      {cards.map((card, index) => (
        <div
          className={`detailShowCard tradeListingGrowingCard ${isShowContent === index && "detailShowCardSpacing"
            }`}
          key={index}>
          <Row className="align-items-start pnlVerifiedRow p-0 m-0">
            <Col
              className={` ${(index === 0 || index === 1) && "mb-md-0 mb-4 p-0"}`}
              md="6"
              sm="12">

              <div className="topTradingBox m-0">
                <div className="contentSide">
                  <p className="name">{card.cardTitle}</p>

                  <p className="numbers">{simplifyTradingVolume(pnlPercentage)}%</p>

                  <p className="subTitle">
                    <span>{simplifyTradingVolume(thisWeekPnlPercentage)}%</span>{" "}
                    Since last week
                  </p>
                </div>
              </div>

              <div className="SwithTitle d-none flex-row mb-0">
                <CustomSwitch
                  checked={isShowContent === index}
                  onChange={() =>
                    setIsShowContent(isShowContent === index ? -1 : index)
                  }
                />

                <span className="switchText">
                  {isShowContent === index ? "Hide Details" : "Show Details"}
                </span>
              </div>
            </Col>

            <Col md="6" sm="12" className="text-end position-relative mb-md-0 mb-4 p-0">
              {/* {index === 0 && isShowContent === index && (
                <div className="verifyTopTradingBox justify-content-end">
                  <div className="switchSide p-0 d-flex justify-content-sm-end justify-content-center">
                    <div className="switchBase">
                      <button
                        className={`${activeButton === "Day" ? "active" : ""}`}
                        onClick={() => setActiveButton("Day")}>
                        Daily
                      </button>
                      <button
                        className={`${activeButton === "Week" ? "active" : ""}`}
                        onClick={() => setActiveButton("Week")}>
                        Weekly
                      </button>

                       <button
                       className={`${
                         activeButton === "Month" ? "active" : ""
                         }`}
                         onClick={() => setActiveButton("Month")}>
                        Monthly
                      </button>
                      <button
                        className={`${
                          activeButton === "All Time" ? "active" : ""
                        }`}
                        onClick={() => setActiveButton("All Time")}>
                        All Time
                      </button>
                    </div>
                  </div>
                </div>
              )} */}
              <div className="d-flex justify-content-sm-end justify-content-center align-items-center gap-2">
                <CommunityAreaChartTabs activeTab={activeTab} onTabChange={setActiveTab} />
              </div>
            </Col>
          </Row>

          {isShowContent === index && (
            <>
              {index === 0 && <TradingGraphPnl activeButton={activeButton} setActiveButton={setActiveButton} user={user} pnlPercentage={pnlPercentage} thisWeekPnlPercentage={thisWeekPnlPercentage} activeTab={activeTab} onTabChange={setActiveTab} market={selectedMarket} />}
              {index === 1 && (
                <>
                  <div className="d-flex flex-column monthlyIncome">
                    <div className="chartBox px-0">
                      <CommunityBarChart
                        duration={index === 0 ? activeButton : "Month"}
                        graphType={index === 0 ? "income" : "growth"}
                        userId={user?._id}
                      />
                    </div>
                  </div>
                </>
              )}
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default TradeListingGrowing;
